import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql, Link } from 'gatsby';

import Wrapper from '../../elements/wrapper';

import { PostGridItem } from '../../blog/posts-grid';
import { media, TransitionMixin } from '../../helpers';

import Wave from '../../../images/waves/home-top-wave.inline.svg';

const BrandedBlogWaveContainer = styled.div`
    top: -25vh;
    margin-bottom: -25vh;
    position: relative;
    z-index: 100;

    .color-bg {
        background-color: #f2f0eb;
        padding: 0 0 150px;
        position: relative;
        bottom: -5vh;
        margin-top: -5vh;
    }
    .svg-container {
        background-color: #f2f0eb;
        position: relative;
        svg {
            width: 100%;
            height: auto;
            position: relative;
            top: 10vh;
            margin-top: -10vh;
            padding-bottom: 10vh;
            path {
                fill: #fff;
                opacity: 1;
            }
        }
    }

    .title-container {
        margin-bottom: 20px;
        z-index: 100;
        position: relative;
        ${media.medium`display: flex; max-width: 81vw;`}

        .title {
            h3 {
                margin: 0;
                color: #000;
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
                font-size: 1.7rem;
            }
        }
        .btn-container {
            flex: 1;
            text-align: right;

            a {
                color: #fff;
                border: none;
                background-color: #f74d33;
                font-weight: 700;
                line-height: 1;
                width: 100%;
                max-width: 150px;
                border-radius: 5px;
                text-decoration: none;
                border: 1px solid #f74d33;
                padding: 15px 0 15px;
                display: inline-block;
                text-align: center;
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
                ${TransitionMixin('.25s')}

                &:hover {
                    color: #f74d33;
                    background-color: #fff;
                }
            }
        }
    }

    .post-grid-wrapper {
        ${media.medium`display: flex; max-width: 82.5vw;`}

        > * {
            flex: 0 0 33.33%;
        }
    }

    .footer-title-container {
        text-align: center;
        padding-top: 10vh;
        h3 {
            margin: 0 0 30px;
            color: #000;
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
            font-size: 3.2rem;
        }

        .btn-container {
            a {
                color: #fff;
                border: none;
                background-color: #f74d33;
                font-weight: 700;
                line-height: 1;
                width: 100%;
                max-width: 200px;
                border-radius: 5px;
                border: 1px solid #f74d33;
                text-decoration: none;
                padding: 20px 0;
                display: inline-block;
                ${TransitionMixin('.25s')}

                &:hover {
                    color: #f74d33;
                    background-color: #fff;
                }
            }
        }
    }
`;

const BrandedBlogWave = ({ handle, waveButton, waveTitle }) => {
    const data = useStaticQuery(graphql`
        query {
            allPosts: allWpPost {
                edges {
                    node {
                        title
                        excerpt
                        content
                        slug
                        featuredImage {
                            node {
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 1000) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                        }
                        categories {
                            nodes {
                                slug
                                name
                            }
                        }
                    }
                }
            }
        }
    `);
    const allPosts = data && data.allPosts.edges;
    const filteredPosts = [];
    allPosts.map((postNode) => {
        let categories = postNode.node.categories.nodes;
        categories.map((category) => {
            if (category.slug === handle) {
                filteredPosts.push(postNode);
            }
        });
    });
    return (
        <BrandedBlogWaveContainer>
            <div className="svg-container">
                <Wave />
            </div>
            <div className="color-bg">
                <Wrapper className="title-container">
                    <div className="title">
                        <h3>You may be interested in...</h3>
                    </div>
                    <div className="btn-container">
                        <Link to={`/blog`}>All posts</Link>
                    </div>
                </Wrapper>

                <Wrapper className="post-grid-wrapper">
                    {filteredPosts &&
                        filteredPosts.slice(0, 3).map((post, index) => {
                            return <PostGridItem key={index} post={post} />;
                        })}
                </Wrapper>

                <Wrapper className="footer-title-container">
                    <h3>{waveTitle}</h3>
                    <div className="btn-container">
                        <Link to={waveButton.url}>{waveButton.title}</Link>
                    </div>
                </Wrapper>
            </div>
        </BrandedBlogWaveContainer>
    );
};

export default BrandedBlogWave;
